import { render, staticRenderFns } from "./PharmacyCategoryUpsertDialog.vue?vue&type=template&id=0ed7d1f2"
import script from "./PharmacyCategoryUpsertDialog.vue?vue&type=script&lang=js"
export * from "./PharmacyCategoryUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports